/**
 * ProcessDiagram
 *
 * A section with a two-column header (title on the left, description on the right)
 * and a full-width process diagram SVG below. Used on consulting service pages
 * to visually explain how a service works step by step.
 *
 * Props:
 * - title (string | ReactNode, required): The bold heading. An orange period is appended automatically.
 * - description (string, required): Short paragraph displayed to the right of the title.
 * - svgSrc (string, required): URL of the process diagram SVG image.
 * - svgAlt (string, optional): Alt text for the diagram image. Defaults to "Process diagram".
 */

const ProcessDiagram = ({ title, description, svgSrc, svgAlt = "Process diagram" }) => {
  return (
    <section className="px-4 md:px-8 lg:px-16 xl:px-24 my-16 lg:my-24 xl:my-52">
      <div className="max-w-7xl mx-auto">

        {/* Header: title left, description right */}
        <div className="flex flex-col md:flex-row gap-8 md:gap-16 mb-12 md:mb-16">
          <div className="md:w-1/2 text-center md:text-left">
            <img
              src="https://sap-app-prod.s3.us-west-2.amazonaws.com/consulting-services/consulting-pages-v2/horizontal-line.svg"
              alt=""
              className="w-28 md:w-40 mb-8 mx-auto md:mx-0"
            />
            <h2 className="text-3xl md:text-4xl lg:text-5xl xl:text-7xl font-bold text-blue-dark1">
              {title}
            </h2>
          </div>
          <div className="md:w-1/2 flex items-end text-center md:text-left">
            <p className="!text-sm md:!text-base xl:!text-2xl leading-relaxed">
              {description}
            </p>
          </div>
        </div>

        {/* Diagram */}
        <img
          src={svgSrc}
          alt={svgAlt}
          className="w-full"
          loading="lazy"
        />
      </div>
    </section>
  );
};

export default ProcessDiagram;
